import { IFaqs } from "@/utils/types";
import { PortableText } from "@portabletext/react";
import { useState } from "react";
import { portableTextComponents } from "./pt";

function FaqItem({
  item,
  open,
  onToggle,
}: {
  item: IFaqs["questions"][number];
  open: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border-b border-white/10 pb-4">
      <div
        className="cursor-pointer flex items-center justify-between gap-4"
        onClick={onToggle}
      >
        <p className="text-xl">{item.question}</p>
        <Chevron open={open} />
      </div>
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden min-h-0">
          <div className="opacity-75 mt-2 rt">
            <PortableText
              value={item.answer}
              components={portableTextComponents}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 transition-transform duration-200 ${
        open ? "rotate-90" : ""
      }`}
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

export function Faqs(props: IFaqs) {
  const questions =
    props.collectionQuestions && props.collectionQuestions.length > 0
      ? props.collectionQuestions
      : props.pickedQuestions && props.pickedQuestions.length > 0
        ? props.pickedQuestions
        : (props.questions ?? []);
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  const [visibleCount, setVisibleCount] = useState(5);

  const toggleFAQ = (index: number) => {
    if (openFAQ === index) {
      setOpenFAQ(null);
    } else {
      setOpenFAQ(index);
    }
  };

  const visibleQuestions = props.vertical
    ? questions.slice(0, visibleCount)
    : questions;

  const hasMore = props.vertical && visibleCount < questions.length;

  if (props.vertical) {
    return (
      <div className="component-padding">
        <div
          style={{
            backgroundColor: props.accentColor || undefined,
            color: props.backgroundColor || undefined,
          }}
          className="flex flex-col bg-darkGrey component-gap p-8 md:p-16 text-white"
        >
          <div className="flex flex-col items-center component-gap text-center">
            <p className="heading w-full">{props.title}</p>
            <p>{props.description}</p>
          </div>
          <div className="flex flex-col gap-4">
            {visibleQuestions.map((item, i) => (
              <FaqItem
                key={i}
                item={item}
                open={openFAQ === i}
                onToggle={() => toggleFAQ(i)}
              />
            ))}
          </div>
          {hasMore && (
            <button
              onClick={() => setVisibleCount((c) => c + 5)}
              className="self-center bg-white font-display text-black py-2 px-4 hover:scale-105 transition-all active:scale-100"
            >
              Bekijk meer
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="component-padding">
      <div
        style={{
          backgroundColor: props.accentColor || undefined,
          color: props.backgroundColor || undefined,
        }}
        className="grid grid-cols-1 bg-darkGrey md:grid-cols-2 component-gap p-8 md:p-16 text-white"
      >
        <div className="flex flex-col component-gap text-center md:text-left">
          <p className="heading">{props.title}</p>
          <p>{props.description}</p>
        </div>
        <div className="flex flex-col gap-4">
          {visibleQuestions.map((item, i) => (
            <FaqItem
              key={i}
              item={item}
              open={openFAQ === i}
              onToggle={() => toggleFAQ(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
